import 'css-chunk:src/feature/settings/SettingsCardReader.module.scss';export default {
  "root": "SettingsCardReader_root"
};